import React from 'react'
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share'
import CourseStore from '../../../../../../../../Store/CourseStore'
import { Subscribe } from 'unstated'
import Modal from '../../../../../../../../../../Components/Modal/Modal'
import { ShareEl } from '../elements'
import { IconButton } from '@material-ui/core'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import { H4 } from '../../../../../../../../../../Styles/typography'
import ClickToCopy from '../../../../../../../../../../Components/ClickToCopy'
import CloseIcon from '@material-ui/icons/Close'

const baseUrl =
  process.env.REACT_APP_ENV === 'production'
    ? 'https://livdemy.com'
    : 'https://app-staging.livdemy.com'

const Share = ({ close }) => {
  return (
    <Subscribe to={[CourseStore]}>
      {({ state: { name } }) => (
        <Modal close={close}>
          <ShareEl>
            <div className='close'>
              <IconButton onClick={() => close()}>
                <CloseIcon />
              </IconButton>
            </div>
            <H4>Share this class on social media</H4>
            <div className='separator' />
            <div className='link'>
              <p className='url'>{baseUrl + window.location.pathname}</p>

              <ClickToCopy data={baseUrl + window.location.pathname}>
                <IconButton>
                  <FileCopyIcon />
                </IconButton>
              </ClickToCopy>
            </div>
            <div className='shareButtons'>
              <FacebookShareButton
                quote={name}
                hashtag='livdemy'
                url={baseUrl + window.location.pathname}
              >
                <FacebookIcon size={48} round />
              </FacebookShareButton>
              <TwitterShareButton
                title={name}
                hashtags={['livdemy']}
                url={baseUrl + window.location.pathname}
              >
                <TwitterIcon size={48} round />
              </TwitterShareButton>
              <WhatsappShareButton
                title={name}
                url={baseUrl + window.location.pathname}
              >
                <WhatsappIcon size={48} round />
              </WhatsappShareButton>
            </div>
          </ShareEl>
        </Modal>
      )}
    </Subscribe>
  )
}

export default Share
